export default "__VITE_ASSET__Dd2s2Ao9__"